export const initialState = {
  forum: {},
  newForum: {},
  forums: [],
  nextTokens: { 1: null },
  loading: false,
  error: null,
  comments: [],
  newComment: {},
  commentNextToken: null,
  commentLoading: false,
  commentNextLoading: false,
  commentError: null,
  commentNextError: null,
  submitCommentLoading: false,
  submitCommentError: null,
  forumCategories: [],
  forumCategoryLoading: false,
  forumCategoryError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_GET_FORUM":
      return {
        ...state,
        forum: {},
        error: null,
        loading: true,
      };
    case "GET_FORUM_SUCCESS":
      return {
        ...state,
        forum: action.payload.forum,
        loading: false,
      };
    case "GET_FORUM_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case "REQUEST_LIST_FORUM":
      return {
        ...state,
        forums: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        error: null,
        loading: true,
      };
    case "LIST_FORUM_SUCCESS":
      return {
        ...state,
        forums: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        loading: false,
      };
    case "LIST_FORUM_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case "REQUEST_CREATE_FORUM":
      return {
        ...state,
        newForum: {},
        error: null,
        loading: true,
      };
    case "CREATE_FORUM_SUCCESS":
      return {
        ...state,
        newForum: action.payload.forum,
        loading: false,
      };
    case "CREATE_FORUM_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case "REQUEST_CREATE_COMMENT":
      return {
        ...state,
        submitCommentError: null,
        submitCommentLoading: true,
        newComment: {},
      };
    case "CREATE_COMMENT_SUCCESS":
      return {
        ...state,
        comments: [action.payload.comment, ...state.comments],
        newComment: action.payload.comment,
        submitCommentLoading: false,
      };
    case "CREATE_COMMENT_ERROR":
      return {
        ...state,
        submitCommentLoading: false,
        submitCommentError: action.payload.error,
      };
    case "REQUEST_LIST_COMMENT":
      return {
        ...state,
        comments: [],
        commentNextToken: null,
        commentError: null,
        commentLoading: true,
      };
    case "LIST_COMMENT_SUCCESS":
      return {
        ...state,
        comments: action.payload.items,
        commentNextToken: action.payload.nextToken,
        commentLoading: false,
      };
    case "LIST_COMMENT_ERROR":
      return {
        ...state,
        commentLoading: false,
        commentError: action.payload.error,
      };
    case "REQUEST_LIST_NEXT_COMMENT":
      return {
        ...state,
        commentNextLoading: true,
        commentNextError: null,
      };
    case "LIST_NEXT_COMMENT_SUCCESS":
      return {
        ...state,
        comments: [...state.comments, ...action.payload.items],
        commentNextToken: action.payload.nextToken,
        commentNextLoading: false,
      };
    case "LIST_NEXT_COMMENT_ERROR":
      return {
        ...state,
        commentNextLoading: false,
        commentNextError: action.payload.error,
      };
    case "REQUEST_LIST_FORUM_CATEGORY":
      return {
        ...state,
        forumCategories: [],
        forumCategoryLoading: true,
        forumCategoryError: null,
      };
    case "LIST_FORUM_CATEGORY_SUCCESS":
      return {
        ...state,
        forumCategories: action.payload.items,
        forumCategoryLoading: false,
      };
    case "LIST_FORUM_CATEGORY_ERROR":
      return {
        ...state,
        forumCategoryLoading: false,
        forumCategoryError: action.payload.error,
      };
    default:
      return state;
  }
};
